<template>
<!--  <div class="instruction col-12" @click="addOne" @click="$emit('selected',{unit:group,msg:message})">-->
  <div class="instruction col-12">
<!--    <h6  @click="addOne">{{message.CookingMsg}}</h6>-->
    <h6>{{message.CookingMsg}}</h6>
    <div v-if="message.Wait" class="d-flex align-items-center">
      <div class="label">
        <button class="qty-btn" @click.stop="removeOne">
          <font-awesome-icon icon="fa-solid fa-minus"/>
        </button>
        <input type="number" :value="message.count" min="0" step="1" readonly>
        <button class="qty-btn" @click.stop="addOne">
          <font-awesome-icon icon="fa-solid fa-plus"/>
        </button>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "Instruction",
  props:{
    message:{
      type:Object,
      required: true,
    },group:{
      type: String,
      required:true
    }
  },
  methods:{
    addOne(){
      if (this.message.Wait){
      this.message.count++
      }
    },
    removeOne(){
      if(this.message.count>1){
        this.message.count--
      }
    }
  }
}
</script>

.instruction {
  padding: 0 16px;
  /* Ensure background is visible. Using a explicit variable + fallback */
  background: var(--bg-secondary, rgba(255, 255, 255, 0.05));
  border: 1px solid var(--card-border);
  height: 60px;
  border-radius: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: var(--text-primary);
  transition: all 0.2s ease;
  margin-bottom: 0; /* Handled by parent */
  position: relative;
  overflow: hidden;

  /* Force glass effect */
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);

  &:hover {
    background: var(--bg-secondary);
    border-color: var(--accent-primary);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-1px);
  }

  h6 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.3px;
    color: var(--text-primary);
    /* Ensure text doesn't wrap weirdly */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 12px;
  }

  .label {
    display: flex;
    align-items: center;
    gap: 8px;
    background: rgba(0, 0, 0, 0.05); /* Subtle container for controls */
    padding: 4px;
    border-radius: 20px;
  }

  /* Target the input specifically to kill the white box */
  input[type="number"] {
    width: 40px;
    height: 32px;
    border: none !important;
    background: transparent !important;
    color: var(--text-primary) !important;
    text-align: center;
    font-weight: 700;
    font-size: 16px;
    padding: 0;
    
    /* Remove spinners */
    -moz-appearance: textfield;
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    &:focus {
      outline: none;
      box-shadow: none;
    }
  }

  .qty-btn {
    width: 32px;
    height: 32px;
    background: var(--card-bg);
    color: var(--text-primary);
    border: 1px solid var(--card-border);
    border-radius: 50%; /* Circle looks cleaner in the pill */
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    font-size: 12px;
    flex-shrink: 0;

    &:hover {
      background: var(--accent-primary);
      color: #fff;
      border-color: var(--accent-primary);
      transform: scale(1.1);
    }

    &:active {
      transform: scale(0.95);
    }
  }
}
